import * as React from 'react';
import IconButton from '@mui/material/IconButton';
import VisibilityIcon from '@mui/icons-material/Visibility';
import { DataGrid } from '@mui/x-data-grid';
import { useState } from 'react';
import { useNavigate } from 'react-router-dom';

export default function DataGridTable({
  appliedStatus,
  VoiceAnayticsaudio,
  appliedUniversities,
  appliedTimelines,
  appliedTerms,
  appliedUnit,
  appliedTeacher,
  appliedPrograms,
}) {
  const navigate = useNavigate();

  const [paginationModel, setPaginationModel] = useState({
    page: 0,
    pageSize: 20,
  });

  const { page, pageSize } = paginationModel;

  // Convert string date (dd-mm-yyyy) to Date object
  function convertToDateObject(dateString) {
    console.warn(dateString);
    const [day, month, year] = dateString.split('-');
    return new Date(`${year}-${month}-${day}`);
  }

  // Calculate rows with correct S.no based on current page and pageSize
  const rows = (VoiceAnayticsaudio || [])
    .filter(
      (item) => appliedStatus.size === 0 || appliedStatus.has(item.status),
    )
    .map((item, index) => ({
      id: item.call_id,
      // sno: page * pageSize + index + 1, // Continuous serial number
      sno: index + 1, // Continuous serial number
      duration: item.duration,
      StudentName: item.student_name,
      callqualityscore: item.call_quality_score,
      Redflagidentified: item.red_flag_status,
      date: convertToDateObject(item.date),
      calltype: item.call_type,
    }));

  // Handle view click for Audio/Video
  const handleViewClick = (params) => {
    const row = params.row;

    if (row && row.id) {
      let route = '';

      if (row.calltype === 'Audio') {
        route = 'studentdeatilsvoiceanalytics';
      } else if (row.calltype === 'Video') {
        route = '/studentdeatilsvoiceanalyticsvideo';
      } else {
        console.error('Unknown call type:', row.calltype);
        return;
      }

      navigate(route, {
        state: {
          StudentName: row.StudentName,
          call_id: row.id,
          appliedUniversities,
          appliedTimelines,
          appliedTerms,
          appliedUnit,
          appliedTeacher,
          appliedPrograms,
        },
      });
    } else {
      console.error('Row or ID is undefined');
    }
  };

  const columns = [
    {
      field: 'sno',
      headerName: 'S.no',
      flex: 0.4,
      align: 'center',
      headerAlign: 'left',
      sortable: false,
    },
    {
      field: 'StudentName',
      headerName: 'Student Name',
      flex: 1.5,
      align: 'left',
      headerAlign: 'left',
    },
    {
      field: 'date',
      headerName: 'Date',
      flex: 1,
      type: 'date',
      align: 'center',
      headerAlign: 'center',
      renderCell: (params) => {
        const date = params.value;
        return date
          ? date.toLocaleDateString('en-US', {
              month: 'short',
              day: '2-digit',
              year: 'numeric',
            })
          : '';
      },
    },
    {
      field: 'duration',
      headerName: 'Duration',
      flex: 0.9,
      align: 'center',
      headerAlign: 'center',
    },
    {
      field: 'callqualityscore',
      headerName: 'Quality Score',
      flex: 1.2,
      align: 'center',
      headerAlign: 'left',
    },
    {
      field: 'calltype',
      headerName: 'Session Type',
      flex: 1,
      align: 'left',
      headerAlign: 'left',
    },
    {
      field: 'Redflagidentified',
      headerName: 'Red Flag Identified',
      flex: 1.3,
      align: 'left',
      headerAlign: 'left',
    },
    {
      field: 'view',
      headerName: 'View',
      flex: 0.6,
      sortable: false,
      align: 'center',
      headerAlign: 'center',
      renderCell: (params) => (
        <IconButton onClick={() => handleViewClick(params)} type="button">
          <VisibilityIcon />
        </IconButton>
      ),
    },
  ];

  return (
    <div style={{ width: '100%' }}>
      <DataGrid
        rows={rows}
        columns={columns}
        paginationModel={paginationModel}
        onPaginationModelChange={(newModel) => setPaginationModel(newModel)}
        autoHeight
        pageSizeOptions={[20, 50, 100]}
        onRowClick={handleViewClick}
        localeText={{ noRowsLabel: 'No Voice Analytics available' }}
        sx={{
          'fontFamily': 'Nunito Sans, sans-serif',
          'fontSize': '14px',
          '& .MuiDataGrid-columnHeaders': {
            backgroundColor: '#ebebeb',
            color: '#000',
            fontWeight: 'bold',
            fontSize: '14px',
            padding: '6px',
          },
          '& .MuiDataGrid-cell': {
            padding: '6px',
            fontSize: '14px',
          },
          '& .MuiDataGrid-row:hover': {
            cursor: 'pointer',
            backgroundColor: '#f5f5f5',
          },
        }}
      />
    </div>
  );
}
